import React, { useId } from "react";
import PropTypes from "prop-types";

const RegistrationIcon = ({ selected, width, height, className, ...props }) => {
  const id = useId().replace(/:/g, "");
  const clipId = `registration-clip-${id}`;

  return (
    <svg width={width || 24} height={height || 24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
      <g clipPath={`url(#${clipId})`}>
        <path
          d="M16 21V19C16 16.7923 14.2077 15 12 15H6.00004C3.79238 15 2.00004 16.7923 2.00004 19V21M19 8V14M22 11H16M5.00004 7C5.00004 9.20766 6.79238 11 9.00004 11C11.2077 11 13 9.20766 13 7C13 4.79234 11.2077 3 9.00004 3C6.79238 3 5.00004 4.79234 5.00004 7Z"
          stroke="white"
          strokeOpacity={selected ? 1 : 0.5}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

RegistrationIcon.propTypes = {
  selected: PropTypes.bool,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
};

RegistrationIcon.defaultProps = {
  selected: false,
  width: undefined,
  height: undefined,
  className: "",
};

export default RegistrationIcon;
